module.exports = __webpack_public_path__ + "img/FüßeImSand.6def6de1.svg";